import Vue from 'vue';
import { BASE_URL, API_URL } from '@/api/const.js';

export default {
    deleteDevice: (id) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({});
            }, 0);
        });
    },

    // get device list
    // prettier-ignore
    fetchDevices() {
		return Vue.http.get(BASE_URL + "userdata/device-list/", {
			//headers: { "Authorization": "MTIuNzkyMzQxNzY2MDU=" }
			headers: { "Authorization:" : "AlertButton " + "MTIuNzkyMzQxNzY2MDU="}
		});
	},

    // fetchDevices() {
    // 	return Vue.http.get(BASE_URL + "userdata/device-list/");
    // },

    // add new device
    sendDevice(newDevice) {
        return Vue.http.get(BASE_URL + 'userdata/device-add/', newDevice);
    },
};
